var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.name))]),_c('div',{staticClass:"main"},[_vm._v(_vm._s(_vm.detail.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }